export default {
      id: "ic-plan-point_tri-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-point_tri-usage",
      toString: function () {
        return this.url;
      }
    }